module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av661-eec60031c09778f07ed9136be90dbe8a.jpg";